import {
  RESET_USER_DETAILS,
  SET_USER_DETAILS,
} from 'shared/constants/ActionTypes';

const initialSettings = {
  user: null,
};

const authReducer = (state = initialSettings, action) => {
  switch (action.type) {
    case SET_USER_DETAILS:
      return {
        ...state,
        user: action.payload,
      };
    case RESET_USER_DETAILS:
      return {
        ...state,
        user: null,
      };

    default:
      return state;
  }
};

export default authReducer;
